import React from "react";

/**
 * Firma > Alt Firmalar tablosunun yükleme iskeleti — SubFirmsTable ile aynı
 * sütun düzeni. MascotLoadingOverlay üstte, iskelet altta kullanılır
 * (bkz. docs/rules/ui-components.md).
 */
// SubFirmsTable ile AYNI sütunlar: iletişim + konum tek sütunda birleşti.
const HEADERS = [
  "FİRMA",
  "İLETİŞİM VE KONUM",
  "KOTA · DAĞITILMAYAN | DAĞITILMIŞ",
  "İŞLEM",
];

const Bar = ({ w = "w-24", h = "h-3.5" }) => (
  <div className={`${h} ${w} bg-gray-200 rounded-md animate-pulse`} />
);

const SubFirmsTableSkeleton = ({ rows = 6 }) => (
  <div className="h-full overflow-auto bg-white border-t border-gray-200">
    <table className="w-full min-w-[1024px] text-sm">
      <thead>
        <tr>
          {HEADERS.map((h, i) => (
            <th
              key={h}
              className={`sticky top-0 z-10 bg-gray-100 border-b border-gray-200 px-4 py-3 text-xs font-bold text-gray-400 tracking-wide whitespace-nowrap ${
                i === HEADERS.length - 1 ? "text-right" : "text-left"
              }`}
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, i) => (
          <tr key={i} className="border-b border-gray-100">
            <td className="px-4 py-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 shrink-0 bg-gray-200 rounded-lg animate-pulse" />
                <div className="space-y-1.5">
                  <Bar w="w-32" />
                  <Bar w="w-24" h="h-3" />
                </div>
              </div>
            </td>
            {/* İletişim + konum tek sütun */}
            <td className="px-4 py-3">
              <div className="space-y-1.5">
                <Bar w="w-40" h="h-3" />
                <Bar w="w-28" h="h-3" />
                <Bar w="w-24" h="h-3" />
              </div>
            </td>
            <td className="px-4 py-3">
              <div className="space-y-1.5">
                <Bar w="w-48" h="h-3" />
                <Bar w="w-44" h="h-3" />
              </div>
            </td>
            <td className="px-4 pr-6 py-3">
              <div className="flex justify-end gap-2">
                <Bar w="w-28" h="h-8" />
                <Bar w="w-10" h="h-8" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SubFirmsTableSkeleton;
